import { useMemo } from 'react';
import { useGetMany, useRecordContext } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { PARAMETER_SUBSET_TYPE } from '@/constants/ParameterSubsetTypes.js';
import { toSubsetIdArray } from '@/helpers/parameter/parameterSubsets.js';
import { getOperatorOptionText, SUBSET_REFERENCE_DISPLAY } from '@/helpers/parameter/parameterSubsetDisplay.js';
import { ParameterChip } from '@/components/parameter/ParameterChip.jsx';

export const ParameterSubsetTargetsField = () => {
    const record = useRecordContext();
    const type = record?.type;
    const ids = toSubsetIdArray(record?.subset);
    const config = SUBSET_REFERENCE_DISPLAY[type];
    const { data: referenced = [] } = useGetMany(config?.reference || 'device-model', { ids }, { enabled: Boolean(config) && ids.length > 0 });

    const labelsById = useMemo(() => {
        const byId = new Map();
        referenced.forEach(item => {
            if (item?.id != null) {
                byId.set(String(item.id), config?.getLabel(item) || String(item.id));
            }
        });
        return byId;
    }, [config, referenced]);

    if (!ids.length) {
        return (
            <Typography variant='body2' className='gray'>
                —
            </Typography>
        );
    }

    if (type === PARAMETER_SUBSET_TYPE.OPERATOR) {
        return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '4px', maxWidth: '200px' }}>
                {ids.map((id, index) => (
                    <ParameterChip key={`${id}-${index}`} label={getOperatorOptionText(id)} />
                ))}
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '4px', maxWidth: '200px' }}>
            {ids.map((id, index) => {
                const label = labelsById.get(String(id)) || String(id);
                return <ParameterChip key={`${id}-${index}`} label={label} />;
            })}
        </Box>
    );
};
